<h2 mat-dialog-title>Inhuur toevoegen</h2>

<mat-dialog-content>
    <ng-select
        class="ng-select-fill employee-select"
        [formControl]="fcEmployee"
        [clearable]="true"
        [items]="filteredEmployees"
        [addTag]="addHiringTagFn"
        [searchFn]="searchFn"
        (change)="onEmployeeChange($event)"
        appendTo="body"
        placeholder="Inhuur"
        bindLabel="name"
        bindValue="id">
        <ng-template ng-tag-tmp let-search="searchTerm"> "{{ search }}" toevoegen als inhuur </ng-template>
        <ng-template ng-option-tmp let-item="item">
            <div class="d-flex justify-content-between w-100 gap-2">
                <span>{{ item.name }}</span>
                <small class="flex-ellipsis">{{ item.companyName ?? item.function }}</small>
            </div>
        </ng-template>
    </ng-select>

    <app-field-input [field]="hiring_id" key="hiring_id" />
</mat-dialog-content>

<mat-dialog-actions class="justify-content-between pt-3">
    <button mat-button mat-dialog-close>Annuleren</button>
    <div class="spacer"></div>
    <button [disabled]="!fcName.value" (click)="add()" mat-raised-button color="primary" mat-dialog-close>
        Toevoegen
    </button>
</mat-dialog-actions>
